import React from 'react';
import { useSelector } from 'react-redux';

import { useAppDispatch } from 'store/hooks';
import { useNavigate } from 'react-router-dom';

import { logoutUser } from 'store/auth/actions';
import { userSelector } from 'store/auth/selectors';

import UserMenu from './UserMenu';

const UserMenuContainer = (props: any) => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const user = useSelector(userSelector);

  const handleAvatarClick = () => {
    navigate('/profile');
  };

  const handleLogoutClick = async () => {
    await dispatch(logoutUser());

    navigate('/');
  };

  if (!user) {
    return null;
  }

  return (
    <UserMenu
      {...props}
      user={user}
      onAvatarClick={handleAvatarClick}
      onLogoutClick={handleLogoutClick}
    />
  );
};

export default React.memo(UserMenuContainer) as any;
